<template>
    <div class="">
        <span>{{ timeStr }}</span>
    </div>
</template>
<script>
export default {
    props: {
        time: {
            type: [Number, String],
            default: () => { }
        },

    },
    data() {
        return {
            countdown: null,
            seconds: 0
        }
    },
    computed: {
        timeStr() {
            var hours = Math.floor(this.seconds / 3600);
            var minutes = Math.floor((this.seconds % 3600) / 60);
            var remainingSeconds = this.seconds % 60;
            return hours.toString().padStart(2, '0') + ":" + minutes.toString().padStart(2, '0') + ":" + remainingSeconds.toString().padStart(2, '0');
        }

    },
    watch: {
        time(val) {
            this.clearTimer();
            this.doLoop();
        }
    },
    created() {
        this.clearTimer();
        this.seconds = this.time;
        if (this.time > 0) {
            this.doLoop();
        }

    },
    methods: {
        clearTimer() {
            clearInterval(this.countdown);
            this.countdown = null;
        },
        endOfTime() {
            this.clearTimer();
        },
        doLoop() {
            this.countdown = setInterval(() => {
                this.seconds--;
                if (this.seconds <= 0) {
                    this.endOfTime();
                    return;
                }
            }, 1000);
        },

    }
}
</script>
<style scoped lang="less"></style>
